/*
 * Purpose : Service Class to handle declare tools create/delete/edit, emails etc services
 * Author : Soban
 * Copyright (c) - Globalfoundries 
 * 
 * Revision History
 * Version  | Date        | Author  | Description
 * -------------------------------------------------------------------------------------
 * 1.0      | 26-Oct-2021 | Soban   | Initial version
 * 
 */

import { API, graphqlOperation, Storage } from "aws-amplify";
import axios from "axios";
import { getExcesstoolpictures } from "../graphql/queries";
export class GetFileDataService {
    async getSavedData(transactionid) {
        let viewDataDetails = {};
        // NEW for CHG0098464: Initialize array to store all transactions across pages
        let allTransactions = [];
        let nextToken = null;
        try {
            // NEW for  CHG0098464 : Use do…while loop to fetch paginated data using nextToken
            // The previous code only fetched one page.
            // Large datasets were returning null in preview even though network response had data.
            do {
                const q = `query 
                    {listExcesstransactionss(limit:${process.env.REACT_APP_TRANSACTION_TABLE_LIMIT}, 
                    ${nextToken ? `nextToken: "${nextToken}",` : ''}  
                    filter:{id:{eq: "${transactionid}" }}){
                        items{
                            transactionid
                            transactiontype
                            txnfab
                            txnmodule
                            txnuemseqptid
                            toolid
                            date
                            approved
                            toolstatus
                            location
                            wafersize
                            initiator
                            reviewer
                            reviewerremarks
                            fabsection
                            toolavailabledate                            
                            txnuniquesutlid
                            txn_assets_mgt_status
                        }
                            nextToken
                    }}`;
                // NEW  for CHG0098464: Await API call and store response

                const response = await API.graphql(graphqlOperation(q))
                const data = response.data.listExcesstransactionss;
                // NEW  for CHG0098464 : Safely append items if present
                //  Optional chaining prevents TypeError when items is undefined
                if (data?.items?.length) {
                    allTransactions = allTransactions.concat(data.items);
                }
                // NEW for CHG0098464: Update nextToken for the next iteration
                nextToken = data?.nextToken ?? null;
            } while (nextToken != null);
            // NEW for CHG0098464: Assign concatenated all pages to viewDataDetails.transaction
            viewDataDetails.transaction = allTransactions;
        } catch (err) {
            // EXISTING: Error handling/logging remains the same
            console.log("err transaction main data=>", err)
            const reqBody = {
                level: "error",
                message: "Error while fetching transaction main data. transactionid : " + transactionid + " , error: " + JSON.stringify(err)
            };
            await axios.post(`${process.env.REACT_APP_REST_API_END_POINT}logtotable`,
                reqBody,
                { headers: { 'x-api-key': process.env.REACT_APP_REST_API_KEY } }
            );
        };
         let q = `query 
                {listExcessgenerals(limit:${process.env.REACT_APP_GENERAL_TABLE_LIMIT}, filter:{transactionid:{eq: "${transactionid}" }}){
                    items{
                        transactionid
                        vendorsupplier
                        model
                        vintage
                        serialno
                        assetdescription
                        softwareversion
                        cim
                        process
                    }
                }}`;
        await API.graphql(graphqlOperation(q))
            .then(
                (PromiseValue) => {
                    //console.log("PromiseValue2",PromiseValue.data.listExcessgenerals.items);
                    viewDataDetails.general = PromiseValue.data.listExcessgenerals.items;
                }
            )
            .catch((err) => {
                console.log("err general=>", err)
                const reqBody = {
                    level: "error",
                    message: "Error while fetching general data. transactionid : " + transactionid + " , error: " + JSON.stringify(err)
                }
                axios.post(`${process.env.REACT_APP_REST_API_END_POINT}logtotable`,
                    reqBody,
                    { headers: { 'x-api-key': process.env.REACT_APP_REST_API_KEY } }
                );
            });
        //var nextToken = null; for CHG0098464
        var hardwarefabSortArr = [];
        do {
            let result = await this.getExcessHardwareFabConfigsFn(nextToken, transactionid);
            if (result.items && result.items.length > 0) {
                hardwarefabSortArr = hardwarefabSortArr.concat(result.items)
            }
            console.log("hardwarefabSortArr  " + JSON.stringify(hardwarefabSortArr));
            nextToken = result.nextToken;
        } while (nextToken != null);

        viewDataDetails.hardwarefab = hardwarefabSortArr;
        q = `query 
                {listExcesshardwaresubfabconfigs(limit:${process.env.REACT_APP_HARDWARESUBFAB_TABLE_LIMIT}, filter:{transactionid:{eq: "${transactionid}" }}){
                    items{
                        transactionid
                        description
                        quantity
                        status
                    }
                }}`;
        await API.graphql(graphqlOperation(q))
            .then(
                (PromiseValue) => {
                    //console.log("PromiseValue4",PromiseValue.data.listExcesshardwaresubfabconfigs.items);
                    viewDataDetails.hardwaresubfab = PromiseValue.data.listExcesshardwaresubfabconfigs.items;
                }
            )
            .catch((err) => {
                console.log("err hardware sub-fab =>", err)
                const reqBody = {
                    level: "error",
                    message: "Error while fetching hardware sub-fab data. transactionid : " + transactionid + " , error: " + JSON.stringify(err)
                }
                axios.post(`${process.env.REACT_APP_REST_API_END_POINT}logtotable`,
                    reqBody,
                    { headers: { 'x-api-key': process.env.REACT_APP_REST_API_KEY } }
                );
            });
//CHG0099515, quantity Filter was removed
        q = `query 
                {listExcessmissingfaultypartss(limit:${process.env.REACT_APP_MISSINGPARTS_TABLE_LIMIT}, filter:{transactionid:{eq: "${transactionid}" }}){
                    items{
                        transactionid
                        description
                        quantity
                    }
                }}`;
        await API.graphql(graphqlOperation(q))
            .then(
                (PromiseValue) => {
                    //console.log("PromiseValue5",PromiseValue.data.listExcessmissingfaultypartss.items);
                    viewDataDetails.missingparts = PromiseValue.data.listExcessmissingfaultypartss.items;
                }
            )
            .catch((err) => {
                console.log("err missing faults=>", err)
                const reqBody = {
                    level: "error",
                    message: "Error while fetching hardware missing faults data. transactionid : " + transactionid + " , error: " + JSON.stringify(err)
                }
                axios.post(`${process.env.REACT_APP_REST_API_END_POINT}logtotable`,
                    reqBody,
                    { headers: { 'x-api-key': process.env.REACT_APP_REST_API_KEY } }
                );
            });

//CHG0099515, quantity Filter was removed
        q = `query 
            {listExcessfaultypartss(limit:${process.env.REACT_APP_FAULTYPARTS_TABLE_LIMIT}, filter:{transactionid:{eq: "${transactionid}" }}){
                items{
                    transactionid
                    description
                    quantity
                }
            }}`;
        await API.graphql(graphqlOperation(q))
            .then(
                (PromiseValue) => {
                    //console.log("PromiseValue5",PromiseValue.data.listExcessfaultyparts.items);
                    viewDataDetails.faultyparts = PromiseValue.data.listExcessfaultypartss.items;
                    console.log('faultyparts ' + JSON.stringify(viewDataDetails.faultyparts))
                }
            )
            .catch((err) => {
                console.log("err faulty items =>", err)
                const reqBody = {
                    level: "error",
                    message: "Error while fetching hardware faulty data. transactionid : " + transactionid + " , error: " + JSON.stringify(err)
                }
                axios.post(`${process.env.REACT_APP_REST_API_END_POINT}logtotable`,
                    reqBody,
                    { headers: { 'x-api-key': process.env.REACT_APP_REST_API_KEY } }
                );
            });


        nextToken = null;
        viewDataDetails.photos = [];
        do {
            let result = await this.getExcesstoolpicturesFn(nextToken, transactionid);
            viewDataDetails.photos = viewDataDetails.photos.concat(result.pics);
            nextToken = result['nextToken'];
        } while (nextToken != null);

        for (const rec of viewDataDetails.photos) {
            //console.log("rec " + JSON.stringify(rec));
            const fileKey = {};
            fileKey.key = rec['toolpicture'];
            //var config = { headers: {'Access-Control-Allow-Origin': '*', 'x-api-key':"eVfRbtokRK4glRHxiJ6dUa61DS3WNGu09UknfimO"} };
            var config = { headers: { 'x-api-key': process.env.REACT_APP_REST_API_KEY } };
            try {
                //rec.toolpicture = await (
                //    await axios.get(
                //       `${process.env.REACT_APP_REST_API_END_POINT}fileDetails?key=` +
                //        fileKey.key, config
                //    )
                //).data.fileData;

                var s3Obj = await Storage.get(fileKey.key, { download: true });

                rec.toolpicture = JSON.parse(JSON.stringify(Buffer.from(await s3Obj.Body.arrayBuffer())));
                console.log("rec.toolpicture==>", rec.toolpicture)
            } catch (error) {
                console.log("err files data from S3=>", error)
                const reqBody = {
                    level: "error",
                    message: "Error while fetching files data data from S3. key : " + fileKey.key + " , error: " + JSON.stringify(error)
                }
                await axios.post(`${process.env.REACT_APP_REST_API_END_POINT}logtotable`, reqBody, { headers: { 'x-api-key': process.env.REACT_APP_REST_API_KEY } });
            }
            //console.log("rec.toolpicture=>", rec.toolpicture);
        }


        viewDataDetails.photos.sort((a, b) =>
            a.systemtype > b.systemtype ? 1 : b.systemtype > a.systemtype ? -1 : 0
        );

        //console.log("viewDataDetails-->", viewDataDetails);
        return viewDataDetails;
    }

    async getLocations() {
        const q = `query 
            {listExcesslocationss(filter: {enable: {eq: "Yes"}}) {
                items{
                    location
                }
            }}`;
        let results = ["..."];
        try {
            await API.graphql(graphqlOperation(q)).then(apiData => {
                apiData.data.listExcesslocationss.items.forEach(item =>
                    results.push(item.location)
                );
                console.log("enabled locations ==>", results.length)
            })
        } catch (error) {
            console.log("error in fetching locations", error)
        }
        results.sort((a, b) => a > b ? 1 : a < b ? -1 : 0)
        return results;
    }
    async getFabs() {
        const q = `query {
            listExcessuemsdatas(limit:${process.env.REACT_APP_UEMS_DATA_TABLE_LIMIT}) {
              items {
                fab
              }
            }
          }
          `;
        let results = ["...", "NA"];
        let resultSet = new Set();
        try {
            await API.graphql(graphqlOperation(q)).then(apiData => {
                apiData.data.listExcessuemsdatas.items.forEach(item =>
                    resultSet.add(item.fab)
                );
                //console.log("fabs set ==>",resultSet)
                let tmpList = [...resultSet].filter(elm => elm.startsWith("FAB"))
                tmpList.push(...[...resultSet].filter(elm => !elm.startsWith("FAB")))
                tmpList.sort(function (a, b) {
                    return +a.split(/(\d+)/)[1] - +b.split(/(\d+)/)[1];
                })
                results.push(...tmpList)
                //results.sort( (a,b) => a>b ? 1 : a<b ? -1 : 0 )
            })
        } catch (error) {
            console.log("error in fetching locations", error)
        }
        return results;
    }

    async getModules(fabid) {
        let results = ["...", "NA"];
        let resultSet = new Set();

        if (fabid === "...") {
            return results;
        }

        const q = `query MyQuery {
            listExcessuemsdatas(filter: {fab: {eq: "${fabid}" }}, limit: ${process.env.REACT_APP_UEMS_DATA_TABLE_LIMIT}) {
              items {
                module
              }
            }
        }`;

        try {
            await API.graphql(graphqlOperation(q)).then(apiData => {
                apiData.data.listExcessuemsdatas.items.forEach(item =>
                    resultSet.add(item.module)
                );
                //console.log("module set ==>",resultSet)
                let tmpList = [...resultSet].sort((a, b) => a > b ? 1 : a < b ? -1 : 0)
                results.push(...tmpList)
                //results.sort( (a,b) => a>b ? 1 : a<b ? -1 : 0 )
            })
        } catch (error) {
            console.log("error in fetching modules", error)
        }
        return results;
    }

    async getUmesEqpId(fabid, module) {
        console.log("fab=> ", fabid, " module : ", module)
        let results = ["...", "NA", "Not available from UEMS"];
        let resultSet = new Set();

        if (fabid === "..." || fabid === "NA" || module === "..." || module === "NA") {
            return results;
        }
        const q = `query MyQuery {
            listExcessuemsdatas(filter: {fab: {eq: "${fabid}"}, and: {module: {eq: "${module}"}}}, limit: ${process.env.REACT_APP_UEMS_DATA_TABLE_LIMIT}) {
              items {
                uems_eqp_id
              }
            }
        }`;

        try {
            await API.graphql(graphqlOperation(q)).then(apiData => {
                //console.log("result ==> ",apiData)
                apiData.data.listExcessuemsdatas.items.forEach(item =>
                    resultSet.add(item.uems_eqp_id)
                );
                //console.log("uems id set ==>",resultSet)
                let tmpList = [...resultSet].sort((a, b) => a > b ? 1 : a < b ? -1 : 0)
                results.push(...tmpList)
                //results.sort( (a,b) => a>b ? 1 : a<b ? -1 : 0 )
            })
        } catch (error) {
            console.log("error in fetching uems ids : ", error)
        }
        return results;
    }
    async getSupplier(fabid, module, uemsid) {
        console.log("fab=> ", fabid, " module : ", module, " uems id : ", uemsid)
        let uniqueId = "";
        let supplier = "";
        let asset_mgt_status = "";
        let txn_uems_remarks = "";

        if (fabid === "..." || fabid === "NA" || module === "..." || module === "NA" || uemsid === "..." || uemsid === "NA") {
            return "";
        }
        const q = `query MyQuery {
            listExcessuemsdatas(filter: {fab: {eq: "${fabid}"}, and: {module: {eq: "${module}"}, and: {uems_eqp_id: {eq: "${uemsid}"}}}}, limit: ${process.env.REACT_APP_UEMS_DATA_TABLE_LIMIT} ) {
              items {
                unique_id
                supplier
                asset_mgt_status
                txn_uems_remarks
              }
            }
        }`;

        try {
            await API.graphql(graphqlOperation(q)).then(apiData => {
                //console.log("result ==> ",apiData)
                apiData.data.listExcessuemsdatas.items.forEach(item => {
                    uniqueId = item.unique_id
                    supplier = item.supplier
                    asset_mgt_status = item.asset_mgt_status
                    txn_uems_remarks = item.txn_uems_remarks
                }
                );
                //console.log("uniqueId ==>",uniqueId)
                //console.log("supplier ==>",supplier)                
            })
        } catch (error) {
            console.log("error in fetching uems ids : ", error)
        }
        return uniqueId + "~" + supplier + "~" + asset_mgt_status + "~" + txn_uems_remarks;
    }

    async checkDuplicateToolId(toolid, txnId) {
        let lengthOfToolList = 0;
        const query = `query MyQuery {
            listExcesstransactionss(filter: {toolid: {eq: "${toolid}" }, and: {transactionid: {ne: "${txnId}" }, and: {approved: {eq: "APPROVED"}}}}, limit: ${process.env.REACT_APP_TRANSACTION_TABLE_LIMIT} ) {
              items {
                toolid
              }
            }
        }`

        try {
            await API.graphql(graphqlOperation(query)).then(apiData => {
                //console.log("result ==> ",apiData)
                console.log("duplicate tool length ==>", apiData.data.listExcesstransactionss.items.length)
                lengthOfToolList = apiData.data.listExcesstransactionss.items.length;
            })
        } catch (error) {
            console.log("error in fetching toolid : ", error)
        }
        return lengthOfToolList;
    }
    async checkUEMSToolAvailability(uemsTool) {
        console.log("UEMS Eqp-ID ==>", uemsTool)
        let lengthOfUEMSEqpId = (uemsTool === "NA" || uemsTool === "Not available from UEMS" || uemsTool === "") ? 1 : 0;

        if (uemsTool === "NA" || uemsTool === "Not available from UEMS" || uemsTool === "") {
            lengthOfUEMSEqpId = 1
            return lengthOfUEMSEqpId;

        }
        const query = `query MyQuery {
            listExcessuemsdatas(filter: {uems_eqp_id: {eq: "${uemsTool}"}}, limit: ${process.env.REACT_APP_UEMS_DATA_TABLE_LIMIT}) {
              items {
                uems_eqp_id
              }
            }
        }`
        try {
            await API.graphql(graphqlOperation(query)).then(apiData => {
                //console.log("result ==> ",apiData)
                console.log("uems eqp tool existing length==>", apiData.data.listExcessuemsdatas.items.length)
                lengthOfUEMSEqpId = apiData.data.listExcessuemsdatas.items.length;
            })
        } catch (error) {
            console.log("error in fetching UEMS Eqp ID : ", error)
        }
        return lengthOfUEMSEqpId;
    }

    async getExcesstoolpicturesFn(nextToken, transactionid) {
        //console.log(" viewDataDetails " + JSON.stringify(viewDataDetails));
        var q = this.getExcesstoolpicturesQuery(nextToken, transactionid);
        var result = {};
        var nextToken = null;
        await API.graphql(graphqlOperation(q))
            .then(async (PromiseValue) => {
                //console.log("PromiseValue6",PromiseValue.data.listExcesstoolpicturess.items);
                let data = PromiseValue.data;
                nextToken = data.listExcesstoolpicturess.nextToken;
                //console.log("pics size " + data.listExcesstoolpicturess.items.length)
                result['pics'] = data.listExcesstoolpicturess.items;
            })
            .catch((err) => {
                console.log("err files data=>", err)
                const reqBody = {
                    level: "error",
                    message: "Error while fetching files data data. transactionid : " + transactionid + " , error: " + JSON.stringify(err)
                }
                axios.post(`${process.env.REACT_APP_REST_API_END_POINT}logtotable`,
                    reqBody,
                    { headers: { 'x-api-key': process.env.REACT_APP_REST_API_KEY } }
                );
            });
        //console.log("nextToken " + nextToken);
        result['nextToken'] = nextToken;
        return result;
    }

    getExcesstoolpicturesQuery(nextToken, transactionid) {
        var s = '';
        if (nextToken) {
            s = 'nextToken:\"' + nextToken + '\",';
        }
        return `query 
            { listExcesstoolpicturess(` + s + ` limit:20000, filter:{transactionid:{eq: "${transactionid}" }}){
                items{
                    transactionid
                    systemtype
                    description
                    toolpicture
                    toolfilename
                    mimetype
                    md5
                }
                nextToken
            }}`;
    };

    async getExcessHardwareFabConfigsFn(nextToken, transactionid) {
        var q = this.getExcessHardwareFabConfigsQuery(nextToken, transactionid);
        var hardwarefabSortArr = [];
        var nextToken = null;
        var result = {};
        await API.graphql(graphqlOperation(q))
            .then(async (PromiseValue) => {
                let data = PromiseValue.data;
                nextToken = data.listExcesshardwarefabconfigs.nextToken;
                data.listExcesshardwarefabconfigs.items.map(item => item.systemtype === "Main System" ? hardwarefabSortArr.push(item) : item);
                data.listExcesshardwarefabconfigs.items.map(item => item.systemtype === "Handler System" ? hardwarefabSortArr.push(item) : item);
                data.listExcesshardwarefabconfigs.items.map(item => item.systemtype === "Factory Interface" ? hardwarefabSortArr.push(item) : item);
                data.listExcesshardwarefabconfigs.items.map(item => item.systemtype === "Options System" ? hardwarefabSortArr.push(item) : item);
                data.listExcesshardwarefabconfigs.items.map(item => item.systemtype === "Others" ? hardwarefabSortArr.push(item) : item);
            })
            .catch((err) => {
                console.log("err hardwarefab confs =>", err)
                const reqBody = {
                    level: "error",
                    message: "Error while fetching hardwarefab confs data. transactionid : " + transactionid + " , error: " + JSON.stringify(err)
                }
                axios.post(`${process.env.REACT_APP_REST_API_END_POINT}logtotable`,
                    reqBody,
                    { headers: { 'x-api-key': process.env.REACT_APP_REST_API_KEY } }
                );
            });
        //console.log("nextToken " + nextToken);
        console.log("nextToken " + nextToken);
        var obj = {};
        result['nextToken'] = nextToken !== undefined ? nextToken : null;
        console.log("hardwarefabSortArr1 " + JSON.stringify(hardwarefabSortArr));
        result['items'] = hardwarefabSortArr;
        console.log("result1 " + JSON.stringify(result));
        return result;
    }

    getExcessHardwareFabConfigsQuery(nextToken, transactionid) {
        var s = '';
        if (nextToken) {
            s = 'nextToken:\"' + nextToken + '\",';
        }
        return `query 
                {listExcesshardwarefabconfigs(` + s + ` limit:${process.env.REACT_APP_HARDWAREFAB_TABLE_LIMIT}, filter:{transactionid:{eq: "${transactionid}" }}){
                    items{
                        transactionid
                        systemtype
                        description
                        quantity
                        status
                    }
					nextToken
                }}`;
    };


}
//module.exports = PostFormService